import React from "react";
import { connect } from "react-redux";
import { isNil } from "lodash";
import { Field, arrayRemove, arrayPush, formValueSelector } from "redux-form";

import CloudUploadOutlined from "@mui/icons-material/CloudUploadOutlined";
import DownloadOutlined from "@mui/icons-material/DownloadOutlined";
import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";

import { getFile } from "../../CroActions";
import CroLabeledCmp from "../../components/generalForm/CroLabeledCmp";
import { StatementFileVisibility } from "../../enum";
import * as V from "../../../../utils/formValidation";
import { isNotLogged, isPublic, isLogged } from "../../CroUtils";
import CroFileUpload, {
  ALLOWED_FILE_ACCEPT,
} from "../../components/generalForm/CroFileUpload";
import Input from "../../../../components/form/Input";
import H from "../../../../agenda/Cro/helpEnum";
import Help from "../../components/Help";

const CroFiles = ({
  publicLabel,
  privateLabel,
  publicButtonLabel,
  privateButtonLabel,
  required,
  files,
  submitFailed,
  auth,
  disabled,
  dispatch,
  arrayPush,
  arrayRemove,
  fileType,
  publicTemplate,
  privateTemplate,
  t,
  helpPrefix,
}) => {
  const getArrayIndexWithVisibility = (array, visibility, fileType) => {
    return array.findIndex((element) => {
      return element.visibility === visibility && element.fileType === fileType;
    });
  };

  const onUpload = (visibility, fileType) => (fileRef) => {
    let index = getArrayIndexWithVisibility(files, visibility, fileType);
    if (index > -1) {
      arrayRemove("files", index);
    }
    arrayPush("files", {
      fileRef: fileRef,
      visibility: visibility,
      fileType: fileType,
    });
  };

  const hasFileRef = isNil(files) ? false : true;
  const publicFileIndex = hasFileRef
    ? getArrayIndexWithVisibility(
        files,
        StatementFileVisibility.PUBLIC,
        fileType,
      )
    : -1;
  const privateFileIndex = hasFileRef
    ? getArrayIndexWithVisibility(
        files,
        StatementFileVisibility.PRIVATE,
        fileType,
      )
    : -1;

  const renderFileSection = ({
    label,
    fileIndex,
    visibility,
    template,
    templateLabel,
    uploadHelpEnum,
    dataHelpEnum,
    templateHelpEnum,
    fileKey,
  }) => (
    <div className="cro-form in">
      <CroLabeledCmp
        title={label}
        required
        labelStyle={
          isNil(files[fileIndex]) && submitFailed ? { color: "red" } : {}
        }
        helpEnum={dataHelpEnum}
      >
        <div className="croFiles__cardGrid">
          {fileIndex > -1 ? (
            <div className="croFiles__card croFiles__card--uploaded">
              <CheckCircleOutlined className="croFiles__cardIcon" />
              <a
                className="croFiles__cardFileName"
                onClick={() => getFile(files[fileIndex].fileRef.id)}
                style={{ color: "#3d4650" }}
              >
                {files[fileIndex].fileRef.name}
              </a>
              {!disabled && (
                <CroFileUpload
                  onFileUploaded={onUpload(visibility, fileType)}
                  url="/api/files/"
                  dispatch={dispatch}
                  helpEnum={uploadHelpEnum}
                  accept={ALLOWED_FILE_ACCEPT}
                >
                  <button className="croFiles__changeBtn">Změnit</button>
                </CroFileUpload>
              )}
              {uploadHelpEnum && (
                <span
                  className="croFiles__cardHelp"
                  onClick={(e) => e.stopPropagation()}
                >
                  <Help helpEnum={uploadHelpEnum} tooltipPosition="top-right" />
                </span>
              )}
            </div>
          ) : !disabled ? (
            <CroFileUpload
              key={fileKey}
              onFileUploaded={onUpload(visibility, fileType)}
              url="/api/files/"
              dispatch={dispatch}
              helpEnum={uploadHelpEnum}
              accept={ALLOWED_FILE_ACCEPT}
            >
              <div className="croFiles__card croFiles__card--upload">
                <CloudUploadOutlined className="croFiles__cardIcon" />
                <span className="croFiles__cardLabel">
                  Klikněte pro nahrání souboru
                </span>
                {uploadHelpEnum && (
                  <span
                    className="croFiles__cardHelp"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Help helpEnum={uploadHelpEnum} tooltipPosition="top-right" />
                  </span>
                )}
              </div>
            </CroFileUpload>
          ) : null}

          {!isNil(template) && (
            <a
              className="croFiles__card croFiles__card--template"
              href={`${process.env.PUBLIC_URL}/files/${template}`}
              download
              style={{ textDecoration: "none", color: "#3d4650!important" }}
            >
              <DownloadOutlined
                className="croFiles__cardIcon"
                style={{ color: "#3d4650" }}
              />
              <span
                className="croFiles__cardLabel"
                style={{ color: "#3d4650" }}
              >
                {templateLabel}
              </span>
              {templateHelpEnum && (
                <span
                  className="croFiles__cardHelp"
                  onClick={(e) => e.stopPropagation()}
                >
                  <Help helpEnum={templateHelpEnum} tooltipPosition="top-right" />
                </span>
              )}
            </a>
          )}
        </div>
      </CroLabeledCmp>
      <Field
        name={`files[${fileIndex}].fileRef.id`}
        component={Input}
        type="hidden"
        style={{ display: "none" }}
        validate={[V.required]}
      />{" "}
      {/*validation*/}
    </div>
  );

  return (
    <div className="cro-form in">
      {renderFileSection({
        label: publicLabel,
        fileIndex: publicFileIndex,
        visibility: StatementFileVisibility.PUBLIC,
        template: publicTemplate,
        templateLabel: "Šablona pro veřejnost",
        uploadHelpEnum: helpPrefix
          ? H[`${t}${helpPrefix}_PUBLICFILE`].r
          : undefined,
        dataHelpEnum: helpPrefix
          ? H[`${t}${helpPrefix}_PUBLICDATA`].r
          : undefined,
        templateHelpEnum: helpPrefix
          ? H[`${t}${helpPrefix}_PUBLICTEMPLATE`].r
          : undefined,
        fileKey: `files[${publicFileIndex}]`,
      })}
      {!(isNotLogged(auth) || (isLogged(auth) && isPublic(auth))) &&
        renderFileSection({
          label: privateLabel,
          fileIndex: privateFileIndex,
          visibility: StatementFileVisibility.PRIVATE,
          template: privateTemplate,
          templateLabel: "Šablona pro správce",
          uploadHelpEnum: helpPrefix
            ? H[`${t}${helpPrefix}_PRIVATEFILE`].r
            : undefined,
          dataHelpEnum: helpPrefix
            ? H[`${t}${helpPrefix}_PRIVATEDATA`].r
            : undefined,
          templateHelpEnum: helpPrefix
            ? H[`${t}${helpPrefix}_PRIVATETEMPLATE`].r
            : undefined,
          fileKey: "fileStatementPrivate",
        })}
    </div>
  );
};

const mapStateToProps = (state, { form }) => ({
  auth: state.sidebar.auth,
  files: formValueSelector(form)(state, "files") || [],
});

const mapDispatchToProps = (dispatch, { form }) => ({
  arrayPush: (field, value) => dispatch(arrayPush(form, field, value)),
  arrayRemove: (field, value) => dispatch(arrayRemove(form, field, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CroFiles);
